// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3yiKE","header":"MergedInvoice_header__7wdwr"};